<template>
  <div style="padding-top: 100px">
    <myHeader/>

    <!-- Main -->
    <div class="main" ref="mainBg">
      <div class="main-title">信用评价结果查询</div>
      <div class="main-search">
        <el-input @keyup.enter.native="doSearch" class="main-search-input" v-model="keywords" clearable></el-input>
        <div class="main-search-btn" @click="doSearch">查询</div>
      </div>
      <div class="main-tap">已为 <span class="tap-num">{{ userNum }}</span> 位用户提供服务 <span
        class="tap-num">{{ searchNum }}</span> 次
      </div>
      <div class="main-module">
        <div v-for="(one, index) in modules" v-bind:key="index" class="one-module">
          <el-image class="one-module-img" :src="one.img"></el-image>
          <div class="one-module-title">{{ one.title }}</div>
          <div class="one-module-link" v-for="(item, no) in one.link" v-bind:key="no">
            <a v-if="item.type === 'hcwz'" :href="item.webUrl" target="_blank">{{ item.name }}</a>
            <div v-if="item.type === 'xydw' || item.type === 'lmdw'" style="cursor:pointer" @click="toDetail(item)">
              {{ item.name }}
            </div>
            <div v-if="item.type === 'wzfw'" style="cursor:pointer" @click="toTip(item)">{{ item.name }}</div>
            <!--            <router-link v-if="item.type === 'wzfw' && userType !== '08'" :to="item.webUrl">{{ item.name }}</router-link>-->
            <!--            <router-link v-if="item.type === 'wzfw' && userType === '08' && item.webUrl === '/submit'" :to="item.webUrl">{{ item.name }}</router-link>-->
          </div>
        </div>
      </div>
    </div>
    <el-image class="main-bg" :src="bgImage"></el-image>
    <myFooter/>
  </div>
</template>

<script>
import {indexSearch, listLeague, listSource, listWeb} from "@/api/common";
import {getServeInfo, getUserType} from "../api/common";
import {isLogin} from "../api/login";
import {MessageBox} from "element-ui";

export default {
  name: 'Index',
  data() {
    return {
      // 用户人数
      userNum: "0",
      // 查询次数
      searchNum: "0",
      // 浏览器页面域高度
      clientHeight: "",
      // 页脚样式 black表适页脚是黑色背景 空为白色背景
      footerBgc: "",
      // 搜索栏输入内容
      keywords: "",
      bgImage: require('../assets/index.jpg'),
      // 从接口获取 首页四个方块区域
      modules: [
        {
          title: "核查网站",
          img: require('../assets/hcwz.png'),
          link: []
        },
        {
          title: "信源单位",
          img: require('../assets/xydw.png'),
          link: []
        },
        {
          title: "联盟单位",
          img: require('../assets/lmdw.png'),
          link: []
        },
        {
          title: "网站服务",
          img: require('../assets/wlfw.png'),
          link: [
            {
              name: "报告查询",
              type: 'wzfw',
              webUrl: "/reportIndex"
            },
            {
              name: "信用自测",
              type: 'wzfw',
              webUrl: "/test"
            },
            {
              name: "数据报送",
              type: 'wzfw',
              webUrl: "/submit"
            }
          ]
        },
      ]
    }
  },
  watch: {},
  created() {
    this.init();
    this.getServeNum();
  },
  mounted() {
  },
  methods: {
    init() {
      let modules = this.modules
      listWeb().then(res => {
        let list = res.data
        modules.forEach(item => {
          if (item.title === "核查网站") {
            list.forEach(one => {
              one.type = 'hcwz'
            })
            item.link = list
          }
        })
      })
      listSource().then(res => {
        let list = res.data
        modules.forEach(item => {
          if (item.title === "信源单位") {
            list.forEach(one => {
              one.type = 'xydw'
            })
            item.link = list
          }
        })
      })
      listLeague().then(res => {
        let list = res.data
        modules.forEach(item => {
          if (item.title === "联盟单位") {
            list.forEach(one => {
              one.type = 'lmdw'
            })
            item.link = list
          }
        })
      })
      this.modules = modules
    },
    toTip(item) {
      isLogin().then(res => {
        if (!res.data) {
          MessageBox.confirm('为了更好地向您提供服务，请先登录本平台', '系统提示', {
              confirmButtonText: '去登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            // 重新登录
            location.href = '#/login';
          }).catch(() => {
          });
        } else {
          getUserType().then(res => {
            if (res.msg === '08' && item.webUrl !== '/submit') {
              this.$alert('此功能仅对企业用户开放！', '提示', {
                confirmButtonText: '确定',
              });
            } else {
              this.$router.push(item.webUrl);
            }
          })
        }
      });
    },
    // 搜索
    doSearch() {
      isLogin().then(res => {
        if (!res.data) {
          MessageBox.confirm('为了更好地向您提供服务，请先登录本平台', '系统提示', {
              confirmButtonText: '去登录',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            // 重新登录
            location.href = '#/login';
          }).catch(() => {
          });
        } else {
          if (!this.keywords) {
            this.$message.info('请输入关键词')
            return
          }
          indexSearch(this.keywords).then(res => {
            this.$router.push({name: 'reportDetail', params: {keywords: this.keywords}})
          })
          this.getServeNum();
        }
      });
    },
    getServeNum() {
      getServeInfo().then(res => {
        this.userNum = res.data.userNum
        this.searchNum = res.data.searchNum
      })
    },
    toDetail(item) {
      this.$router.push({name: 'IndexDetail', params: item})
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 601px;
  background-size: 100% 100%;
  padding-top: 100px;
}

.main-bg {
  position: absolute;
  top: 100px;
  width: 100%;
  height: 700px;
  z-index: -1;
}

.main-title {
  font-size: 36px;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
  margin: 0 auto 20px;
  text-align: center;
  text-shadow: 2px 2px 4px black, -0px -0px 0px white;
}

.main-search {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-search-input {
  width: 472px;
  height: 40px;
  opacity: 1;
  border-radius: 4px;
  margin-right: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-search-btn {
  width: 100px;
  height: 40px;
  border-radius: 4px;
  background: rgba(63, 140, 255, 1);
  font-size: 18px;
  line-height: 18px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.main-tap {
  margin-top: 20px;
  font-size: 14px;
  font-weight: 200;
  color: rgb(255, 255, 255);
//margin: 0 auto 20px; text-align: center;
}

.tap-num {
  font-weight: 700;
  text-shadow: 2px 2px 4px black, -2px -2px 4px black;
//animation: numberRoll 10s steps(100, end) infinite;
}

.main-module {
  width: 100%;
  margin-top: 156px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(255, 255, 255, 1);
}

.one-module {
  width: 288px;
  height: 260px;
  border-radius: 24px;
  background: rgba(133, 190, 255, 0.5);
  margin-right: 12px;
  display: flex;
  flex-direction: column;
}

.one-module:last-child {
  margin-right: 0;
}

.one-module-img {
  width: 60px;
  height: 60px;
  margin: 21px auto 0;
}

.one-module-title {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin: 12px auto;
  text-shadow: 2px 2px 4px black, -0px -0px 0px white;
}

.one-module-link {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 12px;
}

a {
  color: rgba(255, 255, 255, 1);
}

@keyframes numberRoll {
  0% {
    top: 0;
  }
  100% {
    top: -2400px;
  }
  /* 24px multiplied by 100 (number of steps) */
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue